<script lang="ts">
	import t from '$i18n';
	import clsx from 'clsx';
	import { browser } from '$app/environment';
	import {
		BaseButton,
		BaseList,
		BaseListItem,
		BaseMenu,
	} from '@shared/svelte';
	import { onMount } from 'svelte';
	import type {
		AppBarViewModelInterface,
		ProfileMenuOption,
	} from '../app-bar-view-model';

	export let viewModel: AppBarViewModelInterface;

	const {
		currentUserInitials,
		currentUserPhotoURL,
		isNavigating,
		profileMenuOptions,
	} = viewModel;

	let active = false;

	$: active;

	onMount(() => {
		return isNavigating.subscribe((value) => {
			if (value && active) {
				active = false;
			}
		});
	});

	const handleClick = (item: ProfileMenuOption) => {
		if (typeof item !== 'string' && item.click) {
			void item.click();
		}
	};

	const dividerStyle = clsx('border-t border-neutral-100');

	const initialsStyle = clsx({
		'h-full flex items-center justify-center': true,
		'text-lg font-bold text-surface uppercase': true,
	});

	const avatarStyle = clsx({
		'absolute top-0 left-0 h-10 w-10 rounded-full': true,
	});

	$: circleStyle = clsx({
		'bg-gradient': !$currentUserPhotoURL,
		'w-10 h-10 rounded-full cursor-pointer': true,
	});
</script>

<BaseMenu closeOnSelect={false} bind:active={active} class="mv-profile-menu">
	<div slot="activator">
		<div class={circleStyle}>
			{#if browser}
				{#if $currentUserPhotoURL}
					<img
						class={avatarStyle}
						src={$currentUserPhotoURL}
						alt={$t.photo_url()} />
				{:else if $currentUserInitials}
					<span class={initialsStyle}>
						{$currentUserInitials}
					</span>
				{/if}
			{/if}
		</div>
	</div>

	<BaseList>
		{#each $profileMenuOptions as item}
			{#if item === 'divider'}
				<div class={dividerStyle} />
				<!-- {:else if item === 'localeMenu'}
				<LocaleSelector isListItem /> -->
			{:else if item === 'upgradePlan'}
				<BaseButton
					label={$t.upgrade_plan()}
					icon="key"
					color="accent"
					block
					class="children:mr-auto rounded-none"
					on:click={() => viewModel.goToPlanUpgrade()} />
			{:else}
				<BaseListItem
					label={item.text}
					icon={item.icon}
					on:click={() => handleClick(item)} />
			{/if}
		{/each}
	</BaseList>
</BaseMenu>
